import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import IconDone from 'material-ui/svg-icons/action/done';
import IconDecr from 'material-ui/svg-icons/content/remove';
import IconIncr from 'material-ui/svg-icons/content/add';
import TextField from 'material-ui/TextField';
import { red600 } from 'material-ui/styles/colors';
var MaskedInput = require('react-maskedinput');
import PaymentConditions from './payment-conditions';
import Drawer from 'material-ui/Drawer';
import Options from './options';

const paymentConditionsValid = paymentConditions => {
  let paymentConditionValid = true;
  const sum = paymentConditions.reduce((res, val) => res + val.percent , 0);
  if (sum !== 100) {
    paymentConditionValid = false;
  }
  if (paymentConditionValid) {
    paymentConditions.map(condition => {
      if (condition.percent > 0 && (condition.val === '' || condition.val === 0)) {
        paymentConditionValid = false;
      }
      return null;
    });
  }
  return paymentConditionValid;
};

const PrepareOrder = props => {
  const {
    orderConditions,
    comment,
    set,
    decrQty,
    incrQty,
    handleComment,
    handleQty,
    paymentToggle,
    paymentConditionValid,
    handleDateChange,
    handleCommentBlur,
    forAccessories
  } = props;

  const { qty, paymentOn, validationMode } = orderConditions;
  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '1'}}>
      {!forAccessories &&
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <IconButton
            onClick={decrQty}
            iconStyle={{color: 'rgba(0,0,0,0.6)'}}
          >
            <IconDecr />
          </IconButton>
          <TextField
            id='qtyOrder'
            underlineFocusStyle={{borderColor: red600 }}
            value={qty}
            style={{width: '50px'}}
            inputStyle={{textAlign: 'center'}}
            onChange={handleQty}
          />
          <IconButton
            onClick={incrQty}
            iconStyle={{color: 'rgba(0,0,0,0.6)'}}
          >
            <IconIncr />
          </IconButton>
        </div>
      }
      {validationMode && orderConditions.requestedDelivDate === '' &&
        <div style={{color: '#f44336', fontSize: '12px'}}>Неверно указана дата поставки</div>
      }
      <div style={{width: '90%'}}>
        <TextField
          id='reqDateOrder'
          style={{width: '100%'}}
          underlineFocusStyle={{borderColor: red600 }}
          placeholder='Дата поставки'
        >
          <MaskedInput
            mask="11.11.2011"
            name="expiry"
            placeholder="Дата поставки dd.mm.yyyy"
            onChange={handleDateChange}
          />

        </TextField>
      </div>
      {validationMode && !paymentConditionsValid(orderConditions.paymentConditions) &&
        <div style={{color: '#f44336', fontSize: '12px'}}>Неверно заданы условия оплаты</div>
      }
      <div style={{display: 'flex', width: '90%', justifyContent: 'center'}}>
        <FlatButton
          label='Условия оплаты'
          icon={paymentConditionValid ? <IconDone color='#a4c639' /> : null}
          hoverColor='transparent'
          onClick={paymentToggle}
        />
      </div>
      { set && set.options &&
        <Options set={set} validationMode={validationMode} />
      }
      <div style={{width: '90%', display: 'flex', justifyContent: 'center'}}>
        <TextField
          fullWidth={true}
          id='commentOrder'
          underlineFocusStyle={{borderColor: red600 }}
          value={comment}
          multiLine={true}
          placeholder='Комментарий к заказу'
          onChange={handleComment}
          onBlur={handleCommentBlur}
        />
      </div>
      <Drawer
        docked={false}
        width={560}
        open={paymentOn}
        onRequestChange={paymentToggle}
      >
        <div style={{padding: '12px'}}>
          <PaymentConditions paymentToggle={paymentToggle} />
        </div>
      </Drawer>
    </div>
  );
}

PrepareOrder.defaultProps = {
  forAccessories: false
}

class PrepareOrderContainer extends Component {
  constructor() {
    super();
    this.state = { comment: '', paymentConditionValid: false }
  }

  validate = () => {
    const { paymentConditions } = this.props.orderConditions;
    const paymentConditionValid = paymentConditionsValid(paymentConditions);
    this.setState({ paymentConditionValid });
  }

  componentDidMount() {
    this.validate();
  }

  componentWillReceiveProps() {
    this.validate();
  }

  handleDateChange = e => {
    const reqDelivDate = e.target.value;
    const rDate = reqDelivDate ? (new Date(reqDelivDate.slice(6,11), parseInt(reqDelivDate.slice(3,5), 10) - 1, reqDelivDate.slice(0, 2))).toLocaleDateString() : undefined;
    if (rDate !== 'Invalid Date') {
      this.props.dispatch({
        type: 'SET_REQUESTED_DELIV_DATE',
        p: rDate
      })
    }
  }

  paymentToggle = () => {
    const { paymentOn }  = this.props.orderConditions;
    this.props.dispatch({
      type: 'SET_ORDER_PAYMENT_PANE_VISIBILITY',
      p: !paymentOn
    });
  }

  incrQty = () => {
    const { qty }  = this.props.orderConditions;
    this.props.dispatch({
      type: 'SET_ORDER_QTY',
      p: qty + 1
    });
  }
  decrQty = () => {
    const { qty }  = this.props.orderConditions;
    qty > 1 && this.props.dispatch({
      type: 'SET_ORDER_QTY',
      p: this.props.orderConditions.qty - 1
    });
  }

  handleQty = (e, v) => {
    const val = parseInt(v, 10) || 0;
    val >= 0 && this.props.dispatch({
      type: 'SET_ORDER_QTY',
      p: val
    });
  }
  handleComment = (e, v) => {
    this.setState({
      comment: v
    })
  }

  handleCommentBlur = e => {
    this.props.dispatch({
      type: 'SET_ORDER_COMMENT',
      p: e.target.value.trim()
    })
  }

  render () {
    return (
      <PrepareOrder
        {...this.props}
        paymentConditions={this.state.paymentConditions}
        paymentConditionValid={this.state.paymentConditionValid}
        handlePaymentDateSelect={this.handlePaymentDateSelect}
        paymentToggle={this.paymentToggle}
        comment={this.state.comment}
        incrQty={this.incrQty}
        decrQty={this.decrQty}
        handleQty={this.handleQty}
        handleComment={this.handleComment}
        handleDateChange={this.handleDateChange}
        handleCommentBlur={this.handleCommentBlur}
      />
    )
  }
}

export default connect(
  (state, ownProps) => ({ orderConditions: state.ui.orderConditions, set: ownProps.set })
)(PrepareOrderContainer);



// WEBPACK FOOTER //
// ./src/components/layout/content/prepare-order/index.js